(function () {
    'use strict';

    class ImageProtection {
        constructor() {
            this.images = [];
            this.bgElements = [];
            this.isCtrlPressed = false;
            this.observer = null;
            this.init();
        }

        init() {
            console.info("Image protection enabled!");
            this.collectElements();
            this.setupEventListeners();
            this.setupMutationObserver();
        }

        setupMutationObserver() {
            this.observer = new MutationObserver(() => {
                this.collectElements();
                this.applyProtection();
            });

            this.observer.observe(document.body, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['src', 'style']
            });
        }

        collectElements() {
            // Regular images
            this.images = Array.from(
                document.querySelectorAll("img:not([src$='.svg'])")
            ).filter(img =>
                !img.classList.contains('no-image-protection') &&
                img.getAttribute('data-image-protection') !== 'false'
            );

            // Background-image elements
            this.bgElements = Array.from(document.querySelectorAll('*')).filter(el => {
                try {
                    const bg = getComputedStyle(el).backgroundImage;
                    return bg && bg !== 'none' && bg.includes('url(');
                } catch {
                    return false;
                }
            });

            this.applyProtection();
        }

        setupEventListeners() {
            document.addEventListener('keydown', e => this.handleKeyDown(e));
            document.addEventListener('keyup', e => this.handleKeyUp(e));
            document.addEventListener('visibilitychange', () =>
                document.hidden ? this.blurAll() : this.unblurAll()
            );

            window.addEventListener('blur', () => this.blurAll());
            window.addEventListener('focus', () => this.unblurAll());
        }

        applyProtection() {
            // IMG protection
            this.images.forEach(img => {
                img.setAttribute('draggable', 'false');
                img.style.userSelect = 'none';
                img.style.webkitUserSelect = 'none';

                img.addEventListener('contextmenu', e => e.preventDefault());
                img.addEventListener('dragstart', e => e.preventDefault());
            });

            // Background-image protection
            this.bgElements.forEach(el => {
                el.addEventListener('contextmenu', e => e.preventDefault());
                el.addEventListener('dragstart', e => e.preventDefault());

                el.style.userSelect = 'none';
                el.style.webkitUserSelect = 'none';
                el.style.pointerEvents = 'auto'; // keep anchors clickable
            });
        }

        handleKeyDown(e) {
            if (e.key === 'Control' || e.key === 'Meta') {
                this.isCtrlPressed = true;
                this.blurAll();
            }

            if (
                (e.ctrlKey || e.metaKey) &&
                ['c', 's', 'C', 'S'].includes(e.key)
            ) {
                e.preventDefault();
                return false;
            }

            if (e.key === 'PrintScreen' || e.keyCode === 44) {
                this.blurAll();
                e.preventDefault();
                return false;
            }
        }

        handleKeyUp(e) {
            if (e.key === 'Control' || e.key === 'Meta') {
                this.isCtrlPressed = false;
                this.unblurAll();
            }
        }

        blurAll() {
            // Blur <img>
            this.images.forEach(img => {
                img.style.transition = 'none';
                img.style.filter = 'blur(20px)';
            });

            // Blur background images
            this.bgElements.forEach(el => {
                el.style.transition = 'none';
                el.style.filter = 'blur(20px)';
            });
        }

        unblurAll() {
            if (!this.isCtrlPressed && document.hasFocus() && !document.hidden) {
                this.images.forEach(img => {
                    img.style.filter = 'none';
                });

                this.bgElements.forEach(el => {
                    el.style.filter = 'none';
                });
            }
        }
    }

    document.addEventListener('DOMContentLoaded', () => {
        new ImageProtection();
    });
})();
